export default __webpack_public_path__ + "static/media/committee-balaji.46ba27c3.png";